"use strict";
import {
  commonConstants,
  responseCodes,
  successMessagesList,
} from "../_constants";
import { customErrorMessages } from "../../_helpers/custom.messages";
import { removeUserDetails } from "../../_helpers/auth.helper";
import { clearReducer } from "../_actions/auth.actions";

const isSessionUnauthorized = (payload) => {
  if (!payload) {
    return false;
  }
  const httpStatus = payload.status;
  const statusCode = payload.response?.statusCode;
  return (
    httpStatus === 401 ||
    statusCode == responseCodes.AUTH_ERROR_SESSION_TIME_OUT ||
    String(statusCode) === "401"
  );
};

const messageMiddleware = (store) => (next) => (action) => {
  const { message } = store.getState();

  if (action.type === commonConstants.AJAX_ERROR) {
    // API 401 is source of truth for session loss (soft PrivateRoute is UX-only)
    if (isSessionUnauthorized(action.payload)) {
      removeUserDetails();
      store.dispatch(clearReducer());
      if (typeof window !== "undefined" && window.location) {
        window.location.replace("/");
      }
      return next(action);
    }
  }

  if (
    action.type === commonConstants.AJAX_ERROR &&
    action.payload.response != null
  ) {
    // Do not show CSRF token errors; refresh the page to get a new token
    const status = action.payload.status ?? action.payload.response?.statusCode;
    let message =
      action.payload.response?.message ?? action.payload.message ?? "";
    let errorMessage = "";

    if (Array.isArray(message)) {
      errorMessage = message
        .map((m) => (typeof m === "string" ? m : ""))
        .join(" ")
        .toLowerCase();
    } else if (typeof message === "string") {
      errorMessage = message.toLowerCase();
    } else {
      errorMessage = "";
    }

    const errorCode =
      action.payload.response?.error?.code ?? action.payload.error?.code;
    const isCsrfError =
      status == responseCodes.AUTH_ERROR_FORBIDDEN &&
      (errorCode === "EBADCSRFTOKEN" || errorMessage.includes("csrf"));
    if (isCsrfError) {
      if (typeof window !== "undefined" && window.location) {
        window.location.reload();
      }
      return next(action);
    }

    // not showing the common error message
    if (
      responseCodes.AUTH_ERROR_PASSWORD_INCORRECT ==
        action.payload.response.statusCode ||
      responseCodes.AUTH_ERROR_USERNAME_PASSWORD_INCORRECT ==
        action.payload.response.statusCode ||
      responseCodes.AUTH_ERROR_PASSCODE_INCORRECT ==
        action.payload.response.statusCode ||
      responseCodes.AUTH_ERROR_OTP_CONFIRM ==
        action.payload.response.statusCode ||
      responseCodes.AUTH_ERROR_OTP_CONFIRM_INCORRECT ==
        action.payload.response.statusCode ||
      responseCodes.OTP_INCORRECT == action.payload.response.statusCode ||
      responseCodes.INVALIDE_ACCOUNT_NUMBER ==
        action.payload.response.statusCode ||
      responseCodes.AUTH_ERROR_FORGOT_PASSWORD_OTP_CONFIRM_INCORRECT ==
        action.payload.response.statusCode ||
      responseCodes.AUTH_ERROR_FORGOT_PASSWORD_DEBIT_CARD_PIN_INCORRECT ==
        action.payload.response.statusCode ||
      responseCodes.MOBILE_NO_VALIDATION_FAILED ==
        action.payload.response.statusCode ||
      responseCodes?.AUTH_ERROR_CUSTOMER_ONBOARD_PASSWORD_OTP_CONFIRM_INCORRECT ==
        action.payload.response.statusCode ||
      responseCodes.SETTING_TRANSFER_LIMIT_2FA_LIMIT_EXCEED ==
        action.payload.response.statusCode ||
      responseCodes?.AUTH_ERROR_CUSTOMER_ONBOARD_DL_TO_WEB ==
        action.payload.response.statusCode ||
      responseCodes?.AUTH_ERROR_CUSTOMER_ONBOARD_WITH_PASSWORD_EXISTING_DL_USER ==
        action.payload.response.statusCode ||
      responseCodes?.AUTH_ERROR_CUSTOMER_ONBOARD_CUSTOMER_NOT_REGISTERED_WITH_WEB ==
        action.payload.response.statusCode ||
      responseCodes.AUTH_ERROR_ALREADY_ONLY_MOBILE_BANKING_USER ==
        action.payload.response.statusCode ||
      responseCodes?.AUTH_ERROR_CUSTOMER_ONBOARD_FEBA_TO_WEB_MIGRATION_STATUS_EXPIRED ==
        action.payload.response.statusCode ||
      responseCodes?.AUTH_ERROR_CUSTOMER_ONBOARD_SYSTEM_UPGRADED ==
        action.payload.response.statusCode ||
      responseCodes.SAVING_ACCOUNT_OPEN_TRANSFER_FAIL_CODE ==
        action.payload.response.statusCode ||
      responseCodes.INSUFFIENT_BALANCE_STATUS_CODE ==
        action.payload.response.statusCode ||
      responseCodes.OTP_FAILED == action.payload.response.statusCode ||
      responseCodes.ONBOARDING_OTP_FAILED ==
        action.payload.response.statusCode ||
      responseCodes.SERVICE_ERROR_CODE == action.payload.response.statusCode ||
      responseCodes.OTP_EXPIRED == action.payload.response.statusCode ||
      responseCodes.SAVING_ACCOUNT_OPENING_NOT_ELIGIBLE_ERROR_CODE ==
        action.payload.response.statusCode ||
      responseCodes.OTP_REQUEST_LIMIT_REACHED ==
        action.payload.response.statusCode ||
      responseCodes.NO_PERSONAL_ID_FOR_ONBOARD ==
        action.payload.response.statusCode ||
      responseCodes.ONBOARDING_DEBIT_CARD_PIN_INVALID ==
        action.payload.response.statusCode ||
      responseCodes.ONBOARDING_DEBIT_CARD_NUMBER_INVALID ==
        action.payload.response.statusCode ||
      action.payload.response.statusCode ==
        responseCodes.USERNAME_ALREADY_EXISTS ||
      action.payload.response.statusCode ==
        responseCodes.AUTH_ERROR_PASSWORD_EXPIRED ||
      action.payload.response.statusCode ==
        responseCodes.CUSTOMER_ALREADY_REGISTERED_OB ||
      responseCodes.NOTIFICATION_NOT_AVAILABLE ==
        action.payload.response.statusCode ||
      responseCodes.LPOP_BILL_PAYMENT_FAILED ==
        action.payload.response.statusCode ||
      responseCodes.BILL_PAYMENT_FAILED == action.payload.response.statusCode ||
      responseCodes.TRAFFIC_FINE_PAYMENT_FAILURE ==
        action.payload.response.statusCode
    ) {
      let response = action.payload.response;
      // custom error message changes
      if (
        responseCodes.AUTH_ERROR_PASSWORD_INCORRECT ==
          action.payload.response.statusCode ||
        responseCodes.AUTH_ERROR_PASSCODE_INCORRECT ==
          action.payload.response.statusCode ||
        responseCodes.AUTH_ERROR_FORGOT_PASSWORD_DEBIT_CARD_PIN_INCORRECT ==
          action.payload.response.statusCode ||
        responseCodes.MOBILE_NO_VALIDATION_FAILED ==
          action.payload.response.statusCode ||
        // responseCodes.AUTH_ERROR_DL_ACCOUNT_INACTIVE ==
        //   action.payload.response.statusCode ||
        responseCodes.OTP_FAILED == action.payload.response.statusCode ||
        responseCodes.ONBOARDING_OTP_FAILED ==
          action.payload.response.statusCode ||
        responseCodes.SAVING_ACCOUNT_OPENING_NOT_ELIGIBLE_ERROR_CODE ==
          action.payload.response.statusCode ||
        responseCodes.OTP_EXPIRED == action.payload.response.statusCode
      ) {
        response = customErrorMessages(action.payload.response);
      }
      store.dispatch({
        type: commonConstants.SHOW_ERROR_CUSTOM_SERVER_MESSAGE,
        payload: response,
      });
    } else {
      let response = action.payload.response;
      // common error message changes
      if (
        // responseCodes.AUTH_ERROR_ACCOUNT_BLOCK_OTP ==
        //     action.payload.response.statusCode ||
        responseCodes.AUTH_ERROR_ACCOUNT_BLOCK ==
          action.payload.response.statusCode ||
        // responseCodes.AUTH_ERROR_DL_ACCOUNT_BLOCK ==
        //     action.payload.response.statusCode ||
        responseCodes.AUTH_ERROR_ACCOUNT_NOT_ACTIVE ==
          action.payload.response.statusCode ||
        responseCodes.AUTH_ERROR_ADMIN_ACCOUNT_BLOCK ==
          action.payload.response.statusCode ||
        responseCodes.TRANFER_RULE_VIOLATION ==
          action.payload.response.statusCode ||
        responseCodes.TRANSFER_MAXIMUM_LIMIT_VIOLATION ==
          action.payload.response.statusCode ||
        responseCodes.TRANSFER_MINIMUM_LIMIT_VIOLATION ==
          action.payload.response.statusCode ||
        responseCodes.BILL_PAYMENT_MAX_AMNT_ERROR ==
          action.payload.response.statusCode ||
        responseCodes.AUTH_ERROR_DIFFERENT_DEVICE_LOGIN ==
          action.payload.response.statusCode ||
        responseCodes.AUTH_ERROR_SERVICE_SESSION_TIME_OUT ==
          action.payload.response.statusCode ||
        responseCodes.AUTH_ERROR_SERVICE_SESSION_INVALID ==
          action.payload.response.statusCode ||
        responseCodes.AUTH_ERROR_FORGOT_PASSWORD_ADMIN_TEMP_BLOCK ==
          action.payload.response.statusCode ||
        responseCodes.AUTH_ERROR_FORGOT_PASSWORD_ADMIN_BLOCK ==
          action.payload.response.statusCode ||
        responseCodes.AUTH_ERROR_FORGOT_PASSWORD_BLOCK ==
          action.payload.response.statusCode ||
        responseCodes.PAYMENT_NOT_ACCEPT ==
          action.payload.response.statusCode ||
        responseCodes.AUTH_ERROR_FORGOT_PASSWORD_OTP_CONFIRM_ADMIN_BLOCK ==
          action.payload.response.statusCode ||
        responseCodes.AUTH_ERROR_FORGOT_PASSWORD_DO_NOT_HAVE_CARD ==
          action.payload.response.statusCode ||
        // responseCodes.AUTH_ERROR_CUSTOMER_ONBOARD_ACCOUNT_NUMBER_PASSPORT_NOT_MATCH ==
        //   action.payload.response.statusCode ||
        responseCodes.PAYONID_LIMIT_VIOLATION ==
          action.payload.response.statusCode ||
        responseCodes.PAYONID_ACCOUNT_BALANCE_INSUFFICIENT ==
          action.payload.response.statusCode ||
        // responseCodes.CHANGE_PASSWORD_CURRENT_PASSWORD_INCORRECT ==
        //   action.payload.response.statusCode ||
        // responseCodes?.CHECK_PASSWORD_CONTAIN_USERNAME ==
        //   action.payload.response.statusCode ||
        // responseCodes.AUTH_ERROR_CUSTOMER_ONBOARD_WITH_PASSWORD_INVALID_PASSWORD_FORMAT ==
        //   action.payload.response.statusCode ||
        responseCodes.AUTH_ERROR_IB_CUSTOMER_INACTIVE ==
          action.payload.response.statusCode ||
        responseCodes.AUTH_ERROR_IB_ACCOUNT_BLOCK_ADMIN ==
          action.payload.response.statusCode ||
        // responseCodes.AUTH_ERROR_CUSTOMER_ONBOARD_FEBA_TO_WEB_ACCOUNT_BLOCK ==
        //   action.payload.response.statusCode ||
        responseCodes.AUTH_ERROR_USERNAME_PASSWORD_INCORRECT ==
          action.payload.response.statusCode ||
        responseCodes.OB_ACCOUNT_LOCKED == action.payload.response.statusCode ||
        responseCodes.OTP_BLOCKED == action.payload.response.statusCode ||
        responseCodes.APPLICATION_SETTING_PW_CHANGE_TEMP_ACC_LOCKED ==
          action.payload.response.statusCode ||
        responseCodes.ONBOARDING_ACCOUNT_BLOCKED ==
          action.payload.response.statusCode ||
        responseCodes.IDLE_TIMEOUT_LOGOUT_CODE ==
          action.payload.response.statusCode ||
        responseCodes.APPLICATION_SETTING_PW_CHANGE_INCORRECT_PW_ATTEMPT ==
          action.payload.response.statusCode ||
        responseCodes.AUTH_ERROR_PASSWORD_INCORRECT ==
          action.payload.response.statusCode ||
        responseCodes.INVALID_CREDIT_CARD_NUMBER ==
          action.payload.response.statusCode ||
        responseCodes.ADMIN_BLOCKED_ACCOUNT_CODE ==
          action.payload.response.statusCode ||
        responseCodes.OB_BLOCKED_ACCOUNT_CODE ==
          action.payload.response.statusCode ||
        responseCodes.ADMIN_PASSWORD_RESET_CODE ==
          action.payload.response.statusCode ||
        responseCodes.OTP_BLOCKED == action.payload.response.statusCode ||
        responseCodes.FUND_TRANSFER_OWN_ACCOUNT_ERROR_CODE ==
          action.payload.response.statusCode ||
        responseCodes.SETTING_TRANSFER_LIMIT_DAILY_TRNX_LIMT_EXCEED_PER_TRNX_LIMT ==
          action.payload.response.statusCode ||
        responseCodes.SETTING_TRANSFER_LIMIT_CUS_LIMT_LESS_THAN_PER_TRNX_LIMT ==
          action.payload.response.statusCode ||
        responseCodes.SETTING_AUTH_ERROR_PASSWORD_INCORRECT ==
          action.payload.response.statusCode ||
        responseCodes.FD_OPENING_CUSTOMER_NOT_ELIGIBLE_CASA_ACCOUNT ==
          action.payload.response.statusCode ||
        responseCodes.FUND_TRANFER_INSUFFICIENT_FUNDS_ERROR_CODE ==
          action.payload.response.statusCode ||
        responseCodes.INVALID_FUND_TRANSFER_ACCOUNT_NUMBER ==
          action.payload.response.statusCode ||
        responseCodes.TRAFFIC_FINE_PAYMENT_FAILURE ==
          action.payload.response.statusCode ||
        responseCodes.FORGOT_PASSWORD_NIC_ERROR_CODE ==
          action.payload.response.statusCode
      ) {
        response = customErrorMessages(action.payload.response);
      }
      // alert confirmations
      if (
        responseCodes?.AUTH_ERROR_CUSTOMER_ONBOARD_PASSCODE_ALREADY_REGISTERED ==
          action.payload.response.statusCode ||
        responseCodes?.AUTH_ERROR_CUSTOMER_ONBOARD_WEB_PROFILE_ALREADY_COMPLETED ==
          action.payload.response.statusCode
      ) {
        store.dispatch({
          type: commonConstants.SHOW_ERROR_CONFIRM_SERVER_MESSAGE,
          payload: response,
        });
      } else {
        store.dispatch({
          type: commonConstants.SHOW_ERROR_SERVER_MESSAGE,
          payload: response,
        });
      }
    }
  }

  if (action.type === commonConstants.FRONTEND_MESSAGE) {
    store.dispatch({
      type: commonConstants.SHOW_FRONTEND_MESSAGE,
      payload: action.payload,
    });
  }

  if (action.type === commonConstants.AJAX_SUCCESS) {
    store.dispatch({
      type: commonConstants.SHOW_SUCCESS_SERVER_MESSAGE,
      payload: action.payload,
    });
  }

  if (successMessagesList.includes(action.type)) {
    // in here message should be chage accrding to the complete action. Will be added in next releases
    let messageObj = {
      messageAction: action.type,
      message: "Credit card removed successfully!",
    };

    store.dispatch({
      type: commonConstants.SHOW_SUCCESS_SERVER_MESSAGE,
      payload: messageObj,
    });
  }

  next(action);
};

export { messageMiddleware };
